import { render, staticRenderFns } from "./WechatAuth.vue?vue&type=template&id=7011d799&scoped=true"
import script from "./WechatAuth.vue?vue&type=script&lang=js"
export * from "./WechatAuth.vue?vue&type=script&lang=js"
import style0 from "./WechatAuth.vue?vue&type=style&index=0&id=7011d799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7011d799",
  null
  
)

export default component.exports